import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getCaseById, approveCaseLocal, approveCaseMonthly, approveCaseOrg, closeCase } from '../../../services/cases';
import { formatCurrency } from '../../../utils/formatters';
import Toast from '../../../components/Common/Toast';

const CaseApproval = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [caseData, setCaseData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState(null);

  useEffect(() => {
    loadCase();
  }, [id]);

  const loadCase = async () => {
    try {
      const data = await getCaseById(id);
      setCaseData(data);
    } catch (err) {
      setToast({ type: 'error', message: 'Failed to load case' });
    } finally {
      setLoading(false);
    }
  };

  const handleAction = async (action) => {
    try {
      if (action === 'approve_local') await approveCaseLocal(id);
      else if (action === 'approve_monthly') await approveCaseMonthly(id);
      else if (action === 'approve_org') await approveCaseOrg(id);
      else if (action === 'close') await closeCase(id);
      setToast({ type: 'success', message: 'Action completed' });
      navigate('/dashboard/org-admin/cases');
    } catch (err) {
      setToast({ type: 'error', message: err.response?.data?.error });
    }
  };

  if (loading) return <div>Loading...</div>;
  if (!caseData) return <div>Case not found</div>;

  return (
    <div>
      <h1>Case Approval</h1>
      <p><strong>ID:</strong> {caseData.id}</p>
      <p><strong>Type:</strong> {caseData.type}</p>
      <p><strong>Target Amount:</strong> {formatCurrency(caseData.target_amount)}</p>
      <p><strong>Status:</strong> {caseData.status}</p>
      <p><strong>Member:</strong> {caseData.Member?.User?.full_name}</p>
      {caseData.status === 'pending_local' && <button onClick={() => handleAction('approve_local')}>Approve (Local)</button>}
      {caseData.status === 'pending_monthly' && <button onClick={() => handleAction('approve_monthly')}>Approve (Monthly)</button>}
      {caseData.status === 'approved' && <button onClick={() => handleAction('approve_org')}>Open Case</button>}
      {caseData.status === 'open' && <button onClick={() => handleAction('close')}>Close Case</button>}
      {toast && <Toast {...toast} onClose={() => setToast(null)} />}
    </div>
  );
};

export default CaseApproval;